import { render, staticRenderFns } from "./PrintPriceProduct.vue?vue&type=template&id=63901834&scoped=true"
import script from "./PrintPriceProduct.vue?vue&type=script&lang=js"
export * from "./PrintPriceProduct.vue?vue&type=script&lang=js"
import style0 from "./PrintPriceProduct.vue?vue&type=style&index=0&id=63901834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63901834",
  null
  
)

export default component.exports